import { useEffect } from "react";

// Bridge page for The Scoop mobile app. The app opens this page in an
// in-app browser session; we mark the browser session so AuthCallback
// knows to hand the session_id back to the app instead of signing in
// on the web, then run the exact same login flow the web uses.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AppLoginPage = () => {
  useEffect(() => {
    sessionStorage.setItem("scoop_app_auth", "1");
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }, []);

  return (
    <div className="min-h-screen bg-scoop-cream flex items-center justify-center">
      <div className="text-center">
        <div className="font-display text-3xl font-bold text-scoop-ink mb-2">
          The <em className="text-scoop-blue">Scoop</em>
        </div>
        <p className="text-scoop-muted text-sm">Taking you to sign in...</p>
      </div>
    </div>
  );
};

export default AppLoginPage;
